import { computed, defineComponent, onUnmounted, ref } from '@vue/composition-api';
import PageFAQ from '@/components/PageFAQ.vue';
import { PRICING_EXAMPLE, PRICING_TIERS } from '@/static-pages/pricing.const';
import { useGetLocalizedPath } from '@/util/globalHelpers';
import { useMeta } from '@/shared/composables/useMeta';
import useStructuredData from '@/shared/composables/useStructuredData';
import { SITE_URL } from '@/App.vue';
const FAQ_KEYS = ['commission', 'cancel', 'vat', 'leads', 'switch'];
export default defineComponent({
    components: { PageFAQ },
    setup(_, context) {
        const { root } = context;
        const cycle = ref('monthly');
        const { injectStructuredData, ejectStructuredData } = useStructuredData();
        const faqQuestions = computed(() => FAQ_KEYS.map((key) => ({
            question: root.$i18n.t(`pricing.faq.${key}.question`),
            answer: root.$i18n.t(`pricing.faq.${key}.answer`)
        })));
        useMeta({
            title: root.$i18n.t('pricing.meta.title'),
            description: root.$i18n.t('pricing.meta.description'),
            url: `${SITE_URL}${window.location.pathname}`,
            noIndex: false
        });
        onUnmounted(() => {
            ejectStructuredData();
        });
        return {
            cycle,
            example: PRICING_EXAMPLE,
            faqQuestions,
            tiers: PRICING_TIERS,
            injectStructuredData,
            useGetLocalizedPath
        };
    }
});
